import React, { useEffect, useState } from "react";
import { validate } from "../../Input/CheckValidity";
import FormDialog from "../../../helpers/FormDialog";

const CreateModal = (props) => {
  const {
    initialState,
    toggleModal,
    open,
    editObject,
    setSelectedEmployees,
    selectedEmployees,
      employee
  } = props;
  const [list, setList] = React.useState([]);
  const [names, setNames] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [category, setCategory] = useState("");

  const handleClose = () => toggleModal(false);

  useEffect(() => {
    if (editObject.length === 0) {
      setList(JSON.parse(JSON.stringify(initialState)));
    } else {
      setList(JSON.parse(JSON.stringify(editObject)));
    }
  }, [editObject, initialState]);


  useEffect(()=>{
    if(employee){
      setEmail(employee.email);
      setPhone(employee.phone);
      setCategory(employee.category);
      setNames(employee.names);
    }else{
      setEmail("");
      setPhone("");
      setCategory("");
      setNames("");
    }
  },[employee]);

  const validateForm = () => list.filter((v) => !validate(v)[0]).length === 0;

  const submitData = () => {
    // if (validateForm()) {
    const id = new Date().getTime();
    setSelectedEmployees([...selectedEmployees, {id, names, phone, email, category }]);
    handleClose();
    // getValue(JSON.parse(JSON.stringify(list)));
    // list?.forEach((v) => (v.value = ""));
    // }
  };
  const editData = (e) => {
    // e.preventDefault();
    // if (validateForm()) {
      handleClose();
      const emp = selectedEmployees.find(v=>v.id === employee.id);
      emp.names = names;
      emp.phone = phone;
      emp.email = email;
      emp.category = category;
      setSelectedEmployees([...selectedEmployees]);
      // EditValue(JSON.parse(JSON.stringify(list)));
      // list?.forEach((v) => (v.value = ""));
    // }
  };
  return (
    <>
      <FormDialog title={editObject.length !== 0 ? "Edit Participant" : "Add New Participant"} open={open} setOpen={handleClose} fields={[
        {
          name:"names",
          value:names,
          label:"Names",
          required:true,
          setValue:setNames,
        },
        {
          name:"phone",
          type:"tel",
          value:phone,
          label:"Phone Number",
          setValue:setPhone,
        },
        {
          name:"email",
          type:"email",
          value:email,
          label:"Email Address",
          required:true,
          setValue:setEmail,
        },
        {
          name:"title",
          type:"text",
          value:category,
          label:"Title",
          setValue:setCategory,
        },
      ]} beforeSubmit={(event) => {
        handleClose();
        employee ? editData(event) : submitData(event);
      }}/>
      {/*<BootstrapDialog*/}
      {/*  open={open}*/}
      {/*  fullWidth={true}*/}
      {/*  onClose={handleClose}*/}
      {/*  aria-labelledby="modal-modal-title"*/}
      {/*  aria-describedby="modal-modal-description">*/}
      {/*  <form*/}
      {/*    onSubmit={(event) => {*/}
      {/*      editObject.length !== 0 ? editData(event) : submitData(event);*/}
      {/*    }}>*/}
      {/*    <BootstrapDialogTitle*/}
      {/*      id="customized-dialog-title"*/}
      {/*      onClose={handleClose}>*/}
      {/*      {editObject.length !== 0 ? "Edit Participant" : "Add New Participant"}*/}
      {/*    </BootstrapDialogTitle>*/}
      {/*    <DialogContent dividers>*/}
      {/*    <div className="col-md-6 mb-3">*/}
      {/*        <label className="col-form-label fw-bold text-capitalize">*/}
      {/*          Names*/}
      {/*          <span className="text-danger fs-6">*</span>*/}
      {/*        </label>*/}
      {/*        <input*/}
      {/*          type="text"*/}
      {/*          className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"*/}
      {/*          name="names"*/}
      {/*          value={names}*/}
      {/*          required={true}*/}
      {/*          // onBlur={() => {*/}
      {/*          //   setField("name");*/}
      {/*          // }}*/}
      {/*          onChange={(event) => setNames(event.target.value)}*/}
      {/*        />*/}
      {/*        /!* {field === "name" && showError(field, validationMessage)} *!/*/}
      {/*      </div>*/}
      {/*      <div className="col-md-6 mb-3">*/}
      {/*        <label className="col-form-label fw-bold text-capitalize">*/}
      {/*          Phone Number*/}
      {/*        </label>*/}
      {/*        <input*/}
      {/*          type="text"*/}
      {/*          className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"*/}
      {/*          name="phone"*/}
      {/*          value={phone}*/}
      {/*          // onBlur={() => {*/}
      {/*          //   setField("name");*/}
      {/*          // }}*/}
      {/*          onChange={(event) => setPhone(event.target.value)}*/}
      {/*        />*/}
      {/*        /!* {field === "name" && showError(field, validationMessage)} *!/*/}
      {/*      </div>*/}
      {/*      <div className="col-md-6 mb-3">*/}
      {/*        <label className="col-form-label fw-bold text-capitalize">*/}
      {/*          Email*/}
      {/*          <span className="text-danger fs-6">*</span>*/}
      {/*        </label>*/}
      {/*        <input*/}
      {/*          type="text"*/}
      {/*          className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"*/}
      {/*          name="email"*/}
      {/*          value={email}*/}
      {/*          required={true}*/}
      {/*          // onBlur={() => {*/}
      {/*          //   setField("name");*/}
      {/*          // }}*/}
      {/*          onChange={(event) => setEmail(event.target.value)}*/}
      {/*        />*/}
      {/*        /!* {field === "name" && showError(field, validationMessage)} *!/*/}
      {/*      </div>*/}
      {/*      <div className="col-md-6 mb-3">*/}
      {/*        <label className="col-form-label fw-bold text-capitalize">*/}
      {/*          Title*/}
      {/*        </label>*/}
      {/*        <input*/}
      {/*          type="text"*/}
      {/*          className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"*/}
      {/*          name="category"*/}
      {/*          value={category}*/}
      {/*          // onBlur={() => {*/}
      {/*          //   setField("name");*/}
      {/*          // }}*/}
      {/*          onChange={(event) => setCategory(event.target.value)}*/}
      {/*        />*/}
      {/*        /!* {field === "name" && showError(field, validationMessage)} *!/*/}
      {/*      </div>*/}
      {/*      /!* {list.filter((v) => v.hidden !== true).map((field, i) => (*/}
      {/*        <div className={"row"}>*/}
      {/*          <div key={i} className="col-md-2 mb-3">*/}
      {/*            {" "}*/}
      {/*            <label className="col-form-label fw-bolder text-capitalize">*/}
      {/*              {field.label}*/}
      {/*              {field.required === true && (*/}
      {/*                <span className="text-danger fs-6">*</span>*/}
      {/*              )}*/}
      {/*            </label>*/}
      {/*          </div>*/}
      {/*          <div key={i} className="col-md-10 mb-3">*/}
      {/*            <Element*/}
      {/*              field={field}*/}
      {/*              onChange={(event) =>*/}
      {/*                inputChangedHandler(event, field.id, list, setList, false)*/}
      {/*              }*/}
      {/*              ranks={ranks}*/}
      {/*              onBlur={(event) =>*/}
      {/*                inputChangedHandler(event, field.id, list, setList, true)*/}
      {/*              }*/}
      {/*            />*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      ))} *!/*/}
      {/*    </DialogContent>*/}
      {/*    /!* )} *!/*/}
      {/*    <DialogActions>*/}
      {/*      <Button*/}
      {/*        onClick={(event) => {*/}
      {/*          handleClose();*/}
      {/*          setTextValue("");*/}
      {/*        }}*/}
      {/*        color={"error"}>*/}
      {/*        Close*/}
      {/*      </Button>*/}
      {/*      <SubmitButton name={editObject.length !== 0 ? "Edit " : "Add "} />*/}
      {/*    </DialogActions>*/}
      {/*  </form>*/}
      {/*</BootstrapDialog>*/}
    </>
  );
};

export default CreateModal;
